import JSZip from "jszip";
import { createDeployment } from "../models/Deployment";
import { loadOrgModel, loadOrgRecords, loadRecords, saveModel, uploadBlob } from "./connection";
import { createSiteAnchor } from "../models/SiteAnchor";
import { Visual } from "../models/Visual";
import { RobotData } from "../visuals/RobotVisual";
import { createModel, Model } from "../models/Model";
import { createOrgBlob } from "../models/OrgBlob";
import { downloadOrgBlob } from "../panels/common/UploadBlob";
import { createRobot, ROBOCORE_BLOB_CONTAINER } from "../models/Robot";
import { createRemoteControl } from "../models/RemoteControl";
import { getCreds } from "../contexts/PageContext";
import { showSnackbar } from "../components/UniversalDialog";

export async function uploadDeploymentPack(id: string, remoteId: string) {
  showSnackbar("Creating deployment package...", "info");
  const packageName = `remote-deployment-pack-${remoteId}.zip`;
  const stamp = Date.now();
  const cfg = {
    signaling: process.env.REACT_APP_SIGNALING_URL || '',
    deploymentPackStamp: stamp,
    _id: 'current',
  };
  const zip = new JSZip();
  const remote = await loadOrgModel(createRemoteControl(remoteId));
  const robot = await loadOrgModel(createRobot(remote.robotId));
  const recordFolder = zip.folder('records')!;
  recordFolder.file(`remotes-${remote._id}.json`, JSON.stringify(remote, null, 2));
  recordFolder.file(`robots-${robot._id}.json`, JSON.stringify(robot, null, 2));
  recordFolder.file(`config-current.json`, JSON.stringify(cfg, null, 2));

  const blobFolder = zip.folder('blobs')!;
  const deployment = await loadOrgModel(createDeployment(id));
  recordFolder.file(`deployments-${deployment._id}.json`, JSON.stringify(deployment, null, 2));
  // recordFolder.file(`robots-${robot._id}.json`, JSON.stringify(robot, null, 2));
  const site = await loadOrgModel(createSiteAnchor(deployment.siteId));
  recordFolder.file(`siteanchors-${site._id}.json`, JSON.stringify(site, null, 2));
  const visuals = await loadRecords<Visual>('visuals', { siteAnchorId: deployment.siteId });
  showSnackbar(`Including ${visuals.length} visuals in package...`, "info");
  for (const v of visuals) {
    console.log('Including visual', v._id, v.type, 'orgId', v.orgId, '--');
    recordFolder.file(`visuals-${v._id}.json`, JSON.stringify(v, null, 2));
    if (v.type === 'QuadrupedVisual') {
      const robotVisualData = v as RobotData;
      const model = await loadOrgModel(createModel(robotVisualData.modelId));
      recordFolder.file(`models-${model._id}.json`, JSON.stringify(model, null, 2));
      if (model.source.blobId) {
        const blob = await loadOrgModel(createOrgBlob(model.source.blobId));
        recordFolder.file(`orgblobs-${blob._id}.json`, JSON.stringify(blob, null, 2));
        const blobData = await downloadOrgBlob(blob._id);
        blobFolder.file(`${blob._id}.bin`, blobData);
      }
    }
  }
  const models = await loadOrgRecords('models', createModel);
  showSnackbar(`Including ${models.length} models in package...`, "info");
  const stickManModel = models.find(m => m.name === 'StickMan')!;
  const stickManBlob = await loadOrgModel(createOrgBlob(stickManModel.source.blobId!));
  recordFolder.file(`models-${stickManModel._id}.json`, JSON.stringify(stickManModel, null, 2));
  recordFolder.file(`orgblobs-${stickManBlob._id}.json`, JSON.stringify(stickManBlob, null, 2));
  const stickManBlobData = await downloadOrgBlob(stickManBlob._id);
  blobFolder.file(`${stickManBlob._id}.bin`, stickManBlobData);
  // recordFolder.file(`deploymentmeta-stamp.json`, JSON.stringify(
  // { 
  //   deploymentPackStamp: stamp 
  // }, null, 2));
  const { org } = getCreds();
  if (org.imageBlobId) {
    const orgBlob = await loadOrgModel(createOrgBlob(org!.imageBlobId));
    const orgBlobData = await downloadOrgBlob(orgBlob._id);
    blobFolder.file(`banner.bin`, orgBlobData);
    showSnackbar("Uploading deployment package...", "info");
  }
  const zipContent = await zip.generateAsync({ type: "blob" });
  const buffer = await zipContent.arrayBuffer();
  await uploadBlob(ROBOCORE_BLOB_CONTAINER, packageName, buffer);
  remote.deploymentPackStamp = stamp;
  await saveModel(remote);
  showSnackbar("Deployment package uploaded.", "success");
}